// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LrmapXLq8b\\+KZUJDI6Da2Q\\=\\={height:48px;padding:10px;background-color:var(--xds-color-container-subtle);margin-bottom:var(--xds-spacing-e)}", "",{"version":3,"sources":["webpack://./src/pages/Couriers/components/CourierQRCodeManager/components/ConnectionCodeContainer/ConnectionCodeContainer.module.scss"],"names":[],"mappings":"AACA,6BACI,WAAA,CACA,YAAA,CACA,kDAAA,CACA,kCAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"connectionCodeContainer": "LrmapXLq8b+KZUJDI6Da2Q=="
};
export default ___CSS_LOADER_EXPORT___;
